import React from "react";
import UserMetricSummaryView from "@user/components/UserMetricsModal/UserMetricSummaryView";

const ONLINE_MEMBERS_TITLE = "Online members";
const TOTAL_MEMBERS_TITLE = "Total members";

interface RoomMembersSummaryStatsProps {
    readonly onlineMembers: number;
    readonly totalMembers: number;
}
export function RoomMembersSummaryStats(props: RoomMembersSummaryStatsProps) {
    const membersStatsSummary: { title: string; content: string }[] = [
        {
            title: ONLINE_MEMBERS_TITLE,
            content: `${props.onlineMembers}`,
        },
        {
            title: TOTAL_MEMBERS_TITLE,
            content: `${props.totalMembers}`,
        },
    ];

    return <UserMetricSummaryView metrics={membersStatsSummary} />;
}
